(function () {
  'use strict';

  var checkoutSelector = '.zd-drawer-checkout';
  var checkoutUrl = '/checkout';

  function convertCheckoutButton(element) {
    if (!element || !element.matches || !element.matches(checkoutSelector)) return;

    if (element.tagName === 'A') {
      element.setAttribute('href', checkoutUrl);
      element.setAttribute('data-zd-direct-checkout', 'true');
      element.removeAttribute('disabled');
      element.removeAttribute('aria-disabled');
      return;
    }

    var link = document.createElement('a');
    var blockedAttributes = ['type', 'form', 'name', 'disabled', 'aria-disabled'];

    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (blockedAttributes.indexOf(attribute.name) === -1) {
        link.setAttribute(attribute.name, attribute.value);
      }
    });

    link.setAttribute('href', checkoutUrl);
    link.setAttribute('role', 'button');
    link.setAttribute('data-zd-direct-checkout', 'true');
    link.innerHTML = element.innerHTML;
    element.replaceWith(link);
  }

  function upgradeCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(checkoutSelector)) {
      convertCheckoutButton(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(checkoutSelector), convertCheckoutButton);
  }

  function initialise() {
    upgradeCheckoutButtons(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          convertCheckoutButton(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) upgradeCheckoutButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest && event.target.closest(checkoutSelector);
    if (!checkout) return;

    event.preventDefault();
    window.location.assign(checkoutUrl);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('pageshow', function () {
    upgradeCheckoutButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    upgradeCheckoutButtons(event.target || document);
  });
})();
